import { Typography } from "@outschool/backpack";
// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import React from "react";

type TitleProps = {
  title: string;
};

export const Title: React.FunctionComponent<TitleProps> = ({ title }) => {
  return (
    <Typography
      variant="inherit"
      sx={{
        fontSize: "16px",
        lineHeight: "24px",
        color: "grey.900",
        display: "block",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      }}
    >
      {title}
    </Typography>
  );
};
